import React from 'react';

import { TextArea } from '../input';

const Description = () => (
  <TextArea name="description" placeholder="Краткое описание задачи" rows={4} />
);

export default Description;
